export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11067.db4debf6.jpg";